import { createAsyncThunk } from '@reduxjs/toolkit';
import type { StashCategory } from '@stash/shared-types';
import DataService from '../services/data-service';
const dataService = new DataService();
import {
  saveCategoriesStarted,
  saveCategoriesSuccess,
  saveCategoriesFailure,
  loadStashcards,
  addStashcard,
  updateStashcard,
  removeStashcard,
  clearError,
  setLoading,
} from '../reducers/stashcard-reducer';
// Type-only — same shape the reducer's addCase expects. Type-only avoids a
// runtime cycle (the reducer imports the thunks from this file).
import type { CategoryEntry } from '../reducers/stashcard-reducer';

type SaveCategoriesPayload = CategoryEntry | CategoryEntry[] | undefined;

interface ActionError {
  message?: string;
}

export const sync_types = {
  CATEGORIES_SAVE: 'CATEGORIES_SAVE',
} as const;

export const saveCategoryAsync = createAsyncThunk<SaveCategoriesPayload, StashCategory, { rejectValue: string }>(
  'stashcard/saveCategoryAsync',
  async (category, { rejectWithValue }) => {
    try {
      const response = await dataService.saveCategories([category]);
      // dataService.saveCategories returns Promise<unknown>; the reducer expects
      // the saved category/categories shape, so we narrow at this boundary.
      return response as SaveCategoriesPayload;
    } catch (err) {
      const error = err as ActionError;
      return rejectWithValue(error.message || 'Failed to save category');
    }
  },
);

export const saveCategoriesAsync = createAsyncThunk<SaveCategoriesPayload, StashCategory[], { rejectValue: string }>(
  'stashcard/saveCategoriesAsync',
  async (categories, { rejectWithValue }) => {
    try {
      const response = await dataService.saveCategories(categories);
      return response as SaveCategoriesPayload;
    } catch (err) {
      const error = err as ActionError;
      return rejectWithValue(error.message || 'Failed to save categories');
    }
  },
);

export function saveCategory(category: StashCategory): ReturnType<typeof saveCategoryAsync> {
  return saveCategoryAsync(category);
}

export {
  saveCategoriesStarted,
  saveCategoriesSuccess,
  saveCategoriesFailure,
  loadStashcards,
  addStashcard,
  updateStashcard,
  removeStashcard,
  clearError,
  setLoading as setStashcardLoading,
};
